<td *ngIf="_dataTable.inputHasCheckboxes">
    <mat-checkbox
        [ngModel]="row.selected"
        [disabled]="row.disabled"
        (change)="_dataTable.onRowCheckboxChange(row)"
        (click)="$event.stopPropagation()"
    >
    </mat-checkbox>
</td>
<ng-content></ng-content>
